//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as empTagApi from '@/api/empTagApi.js';
import { Debounce } from '@/utils/validate';
export default {
  name: 'EditTag',
  data: function data() {
    return {
      loading: false,
      visible: false,
      formData: {
        tagName: ''
      },
      editId: null,
      rules: {
        tagName: [{
          required: true,
          message: '请输入标签名称',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    openInit: function openInit(row) {
      var _this = this;
      this.editId = row.id || null;
      this.formData = {
        tagName: row.tagName || ''
      };
      this.visible = true;
      this.$nextTick(function () {
        if (_this.$refs.form) {
          _this.$refs.form.clearValidate();
        }
      });
    },
    handleSubmit: Debounce(function () {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var params = {
          tagName: _this2.formData.tagName
        };
        if (_this2.editId) {
          params.id = _this2.editId;
        }
        var apiMethod = _this2.editId ? empTagApi.updateTag : empTagApi.addTag;
        apiMethod(params).then(function () {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};